import { useState } from "react";
import type { CSSProperties } from "react";
import { SocialAccountDto } from "@cede/types";
import { firstLetterToUpperCase } from "@cede/utils";
import { ProfileSocialsList } from "./ProfileSocialsList";
import { Confirm } from "@/components/shared/Confirm";
import { useSocialAccounts } from "@/hooks/socials/useSocialAccounts";

interface ProfileSocialsProps {
  className?: string;
  style?: CSSProperties;
}

export function ProfileSocials({ className, style }: ProfileSocialsProps) {
  const [socialAccountToRemove, setSocialAccountToRemove] = useState<SocialAccountDto | null>(null);
  const [openRemoveSocialModal, setOpenRemoveSocialModal] = useState(false);
  const {
    socialAccounts,
    addSocialAccount,
    removeSocialAccount,
    isLoading,
    isRemovingSocialAccount,
    isAddingSocialAccount,
  } = useSocialAccounts();

  return (
    <>
      <Confirm
        open={openRemoveSocialModal}
        title="Are you sure?"
        description={`This will unlink your ${firstLetterToUpperCase(
          socialAccountToRemove?.socialName || "",
        )} account. You can always link
          it again later`}
        confirmText="Yes, remove"
        onConfirm={() => {
          if (socialAccountToRemove) {
            removeSocialAccount.mutate(socialAccountToRemove);
            setOpenRemoveSocialModal(false);
          }
        }}
        onClose={() => {
          setOpenRemoveSocialModal(false);
        }}
      />
      <ProfileSocialsList
        onLink={(socialName) => {
          addSocialAccount.mutate(socialName);
        }}
        onRemove={(socialAccount) => {
          setSocialAccountToRemove(socialAccount);
          setOpenRemoveSocialModal(true);
        }}
        addSocialAccountLoading={isAddingSocialAccount}
        removeSocialAccountLoading={isRemovingSocialAccount}
        socialAccounts={socialAccounts}
        isLoading={isLoading}
        className={className}
        style={style}
      />
    </>
  );
}
